module.exports = "<navbar></navbar>\n<router-outlet></router-outlet>\n<footer></footer>\n"